import React, { useEffect, useState } from "react";
import { Loading3QuartersOutlined } from "@ant-design/icons";
import { Document } from "react-pdf";
import {
	formularioSeleccionadoAtom,
	urlFirmaHolografaAtom,
	urlHuellaDactilarAtom,
	urlFotoAtom,
	loadingPdfAtom,
} from "pages/v3/mis-pendientes/componentes/MisDocumentosWeb/MisDocumentosWebStorage";
import { useAtom } from "jotai";
import { PortalColaboradorService } from "services/PortalColaboradorService";
import PaginaPdf from "./PaginaPdf";
import BarraHerramientas from "./BarraHerramientas";
import { Alert } from "antd";
import { SolicitudAusenciaService, TareasPendientesService } from "services";
import { CategoriaDocumento } from "enum/CategoriaDocumento";

export function Body({ control }) {
	const [formularioSeleccionado] = useAtom(formularioSeleccionadoAtom);
	const [totalPaginas, setTotalPaginas] = useState(undefined);
	const [urlPdf, setUrlPdf] = useState(undefined);
	const [componentes, setComponentes] = useState(undefined);
	const [variablesFormulario, setVariablesFormulario] = useState(undefined);
	const [parametrosFormulario, setParametrosFormulario] = useState(undefined);
	const [datosFormulario, setDatosFormulario] = useState(undefined);
	const [loading, setLoading] = useState(false);

	const [, setUrlFirmaHolografa] = useAtom(urlFirmaHolografaAtom);
	const [, setUrlHuellaDacilar] = useAtom(urlHuellaDactilarAtom);
	const [, setUrlFoto] = useAtom(urlFotoAtom);
	const [, setLoadingPdf] = useAtom(loadingPdfAtom);

	useEffect(() => {
		const obtenerUrlPlantillaPdf = async () => {
			setLoading(true);

			let respuesta = undefined;
			if (formularioSeleccionado.categoriaDocumentoId === CategoriaDocumento.TAREA_PENDIENTE) {
				respuesta = await TareasPendientesService.buscarPorId(formularioSeleccionado.tareaPendienteId);
				//se hace esta conversión porque se está reutilizando el api de tareaspendientes y las variables se encuentran variablesGlobales
				respuesta.variablesFormulario = respuesta.variablesGlobales;
			} else {
				respuesta = await PortalColaboradorService.obtenerDatosFormulario(
					formularioSeleccionado.categoriaDocumentoId === CategoriaDocumento.FLUJO_FIRMA
						? formularioSeleccionado.flujoFirmaId
						: formularioSeleccionado.formularioId,
					formularioSeleccionado.id
				);
			}

			if (respuesta.solicitudAusenciaId) {
				const variablesAusencia = await SolicitudAusenciaService.obtenerDatosSolicitudAusencia({
					solicitudAusenciaId: respuesta.solicitudAusenciaId,
				});
				//console.log("Todas las variables", variablesAusencia);
				Object.assign(respuesta.variablesFormulario, variablesAusencia.data);
			}
			setUrlPdf(respuesta.urlPlantillaPdfFirmada);
			setComponentes(respuesta.componentes);
			setVariablesFormulario(respuesta.variablesFormulario);
			setParametrosFormulario(respuesta.parametrosFormulario);
			setDatosFormulario(respuesta.datosFormulario);
			if (respuesta.urlFirmaHolografa !== undefined) setUrlFirmaHolografa(respuesta.urlFirmaHolografa);
			if (respuesta.urlHuellaDactilar !== undefined) setUrlHuellaDacilar(respuesta.urlHuellaDactilar);
			if (respuesta.urlFoto !== undefined) setUrlFoto(respuesta.urlFoto);
		};
		obtenerUrlPlantillaPdf();
	}, [formularioSeleccionado]);

	const onLoadSuccess = async (successEvent) => {
		setTotalPaginas(successEvent.numPages);
		setLoading(false);
		setLoadingPdf(false);
	};

	return (
		<div
			style={{
				height: formularioSeleccionado?.motivoRechazo !== null ? "calc(90% - 64px)" : "calc(100% - 64px)",
			}}
		>
			{loading && (
				<div className="visor-formulario-loading">
					<Loading3QuartersOutlined spin className="loading" />
				</div>
			)}
			<BarraHerramientas />
			{formularioSeleccionado?.motivoRechazo !== null && (
				<div style={{ zIndex: 0 }}>
					<Alert
						message="Formulario Rechazado"
						description={"Motivo de Rechazo : " + formularioSeleccionado?.motivoRechazo}
						type="warning"
						showIcon
					//closable
					/>
				</div>
			)}
			<div className="visor-formulario-body">
				<Document file={urlPdf} onLoadSuccess={onLoadSuccess} loading={null}>
					{Array.from(new Array(totalPaginas), (el, index) => (
						<PaginaPdf
							key={`page_${index + 1}`}
							numeroPagina={index + 1}
							componentes={componentes}
							variablesFormulario={variablesFormulario}
							datosFormulario={datosFormulario}
							parametrosFormulario={parametrosFormulario}
							control={control}
						/>
					))}
				</Document>
			</div>
		</div>
	);
}
